import { utils } from '@febos-io/common';

const version = import.meta.env.NX_VERSION || '1.0.0';

export const initialState = { version };

const reducer = utils.createReducer('app', initialState, {});

export default reducer;
